import React from 'react';

import { MDText } from 'i18n-react';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import car from '../../../../../../client/assets_seller/ulez/car.svg';
import motorbikes from '../../../../../../client/assets_seller/ulez/motorbikes.svg';
import LocalTexts from '../ulezText.json';

import styles from './Home.scss';

type Props = {
  readonly bodyText: String;
  readonly title: String;
}

const LocalT = new MDText(LocalTexts);

const Scheme = ({ bodyText, title }: Props) => (
  <section className={styles.scheme}>
    <ComponentContent className={styles.schemeContainer} maxWidth={CONTENT_SIZES.container}>
      <h3 className={styles.schemeTitle}>{title}</h3>
      <div dangerouslySetInnerHTML={{ __html: bodyText as string }} className={styles.schemeDesc} />
      <p className={styles.schemeInfo}>{LocalT.translate('scheme.qualify')}</p>
      <div className={styles.schemeBoxes}>
        <div className={styles.box}>
          <div className={styles.graphic}>
            <img
              alt="motorbikes"
              height="72"
              loading="lazy"
              src={motorbikes}
              width="84"
            />
          </div>
          <div>
            <span className={styles.badge}>
              {LocalT.translate('scheme.box1.value')}
            </span>
            <p>{LocalT.translate('scheme.box1.text')}</p>
          </div>
        </div>
        <div className={styles.box}>
          <div className={styles.graphic}>
            <img
              alt="car"
              height="72"
              loading="lazy"
              src={car}
              width="84"
            />
          </div>
          <div>
            <span className={styles.badge}>
              {LocalT.translate('scheme.box2.value')}
            </span>
            <p>{LocalT.translate('scheme.box2.text')}</p>
          </div>
        </div>
      </div>
    </ComponentContent>
  </section>
);

export default Scheme;
